<script lang="ts">
  import { MODE, STUDIO_ENV } from '@webplayer/constants/attributes';
  import { EventType } from '@webplayer/constants/events';
  import { FormGroup, RadioButton, RadioButtonGroup, TextInput } from 'carbon-components-svelte';

  import type { AttributeOptions } from '../modules/attributes';

  type Props = {
    attributes: AttributeOptions;
  };
  const { attributes }: Props = $props();
</script>

<FormGroup legendText="Select a Studio Environment">
  <RadioButtonGroup bind:selected={attributes.studio}>
    <RadioButton data-testid={STUDIO_ENV.NOT_STUDIO} value={STUDIO_ENV.NOT_STUDIO} labelText="Not Studio" />
    <RadioButton data-testid={STUDIO_ENV.STUDIO_PROD} value={STUDIO_ENV.STUDIO_PROD} labelText="Studio Prod" />
    <RadioButton data-testid={STUDIO_ENV.STUDIO_INT} value={STUDIO_ENV.STUDIO_INT} labelText="Studio Int" />
    <RadioButton data-testid={STUDIO_ENV.STUDIO_LOCAL} value={STUDIO_ENV.STUDIO_LOCAL} labelText="Studio Local" />
  </RadioButtonGroup>
</FormGroup>

<FormGroup legendText="Select an Event Type">
  <RadioButtonGroup bind:selected={attributes.type}>
    <RadioButton data-testid="type--null" value={''} labelText="Null" />
    <RadioButton data-testid="type--event" value={EventType.EVENT} labelText="Event" />
    <RadioButton data-testid="type--library" value={EventType.LIBRARY} labelText="Library" />
    <RadioButton data-testid="type--playlist" value={EventType.PLAYLIST} labelText="Playlist" />
  </RadioButtonGroup>
</FormGroup>
<FormGroup legendText="Select a Manifest Type">
  <RadioButtonGroup bind:selected={attributes.manifestType}>
    <RadioButton data-testid="player--dash" value="dash" labelText="DASH" />
    <RadioButton data-testid="player--hls" value="hls" labelText="HLS" />
  </RadioButtonGroup>
</FormGroup>
<FormGroup legendText="Select a Player Mode">
  <RadioButtonGroup bind:selected={attributes.mode}>
    <RadioButton data-testid="mode--default" value={`${MODE.DEFAULT}`} labelText="Default" />
    <RadioButton data-testid="mode--live" value={`${MODE.LIVE}`} labelText="Live" />
  </RadioButtonGroup>
</FormGroup>
<FormGroup legendText="Select an Environment (For Data Purposes)">
  <RadioButtonGroup bind:selected={attributes.env}>
    <RadioButton data-testid="env--int" value={'int'} labelText="Integration" />
    <RadioButton data-testid="env--prod" value={'prod'} labelText="Production" />
  </RadioButtonGroup>
</FormGroup>
<FormGroup legendText="iFrame Id">
  <TextInput
    data-testid="string--iframeId"
    size="sm"
    bind:value={attributes.iframeId}
    placeholder="Enter iFrame id..." />
</FormGroup>
